import AdviserSummary, { AdviserSummaryProvider } from "../../features/advisersummary";
import PageHeader, { PageHeaderTop } from "../../components/layout/PageHeader";
import { Main } from "../../components/utilities";
import { PageHeaderTitle } from "../../components/utilities/PageHeader";
import { useAuth } from "react-oidc-context";

const AdviserSummaryDashboardPage = () => {
    const auth = useAuth();
    return (
        <>
            <PageHeader>
                <PageHeaderTop>
                    <PageHeaderTitle>
                        <span>Summary Home Page</span>
                    </PageHeaderTitle>
                </PageHeaderTop>
            </PageHeader>
            <Main className="d-flex flex-column">
                <AdviserSummaryProvider user={auth.user}>
                    <AdviserSummary />
                </AdviserSummaryProvider>
            </Main>
        </>
    );
}

export default AdviserSummaryDashboardPage;